import { useCallback, useState } from "react";
import { useRouter } from "next/router";
import { useStepEmailRouterSync } from "./useStepEmailRouterSync";

export type StepEmailController = {
	prefilledEmail: string;
	isErrorModalOpen: number;
	isRouterReady: boolean;
	openErrorModal: (index: number) => void;
};

export default function useStepEmailController(): StepEmailController {
	const router = useRouter();
	const [isErrorModalOpen, setIsErrorModalOpen] = useState(0);
	const [prefilledEmail, setPrefilledEmail] = useState<string>("");

	const rawError = router.query["error"];
	const errorParam = typeof rawError === "string" ? rawError : undefined;
	const rawEmailQuery = router.query["email"];
	const emailQuery = typeof rawEmailQuery === "string" ? rawEmailQuery : undefined;

	const openErrorModal = useCallback((index: number) => {
		setIsErrorModalOpen(index);
	}, []);

	useStepEmailRouterSync({
		router,
		emailQuery,
		errorParam,
		openErrorModal,
		setPrefilledEmail,
	});

	return {
		prefilledEmail,
		isErrorModalOpen,
		isRouterReady: router.isReady,
		openErrorModal,
	};
}
